function isIframeEmbed(): boolean {
  const pathname = window.location.pathname;
  if (!pathname) {
    return false;
  }
  // avoids hyphenated paths like /embeds-not-this-route
  return pathname === '/embeds' || pathname.startsWith('/embeds/');
}

export default isIframeEmbed;
